'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { env } from '@/constant/process';

import { flushMetrics, incrementRenderFinish } from '.';

/** Fires an event to VMI once root > main is populated */
export default function VMIRenderTracking() {
  const pathname = usePathname();

  useEffect(() => {
    if (env.nodeEnv === 'test') return;

    const main = document.querySelector('main');
    if (!main) return;

    const hasPageContent = (main.textContent?.trim().length ?? 0) > 0;

    if (!hasPageContent) return;

    incrementRenderFinish({ locale: env.publicLocale });
    flushMetrics();
  }, [pathname]);

  return null;
}
